import { useEffect } from "react";
import AOS from "aos";


const InitAnimations = () => {
    useEffect(
        () => { 
            AOS.init({
                duration: 800,
                once: true, // sadece bir kez çalışır (reflow'ları azaltır)
                mirror: false, // scroll yukarı çıkarken tekrar animasyon yapmaz
            }) 
        }, []
    );
    return null;
}

export default InitAnimations;
